import { render } from "./PopinDefault.vue?vue&type=template&id=735296c2&scoped=true"
import script from "./PopinDefault.vue?vue&type=script&lang=js"
export * from "./PopinDefault.vue?vue&type=script&lang=js"

import "./PopinDefault.vue?vue&type=style&index=0&id=735296c2&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Anael\\Documents\\developpement\\teachup-video-interactive\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-735296c2"]])

export default __exports__